(function () {
  function initSection(section) {
    if (!section || section.dataset.ruHomeGridProdV2Init === "true") return;
    section.dataset.ruHomeGridProdV2Init = "true";

    var cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

    section.addEventListener(
      "click",
      function (e) {
        if (e.target.closest('form[data-open-cart-drawer="true"]')) {
          e.stopPropagation();
        }
      },
      true
    );

    section.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.matches('form[data-open-cart-drawer="true"]')) return;

      e.preventDefault();
      e.stopPropagation();

      var button = form.querySelector('[type="submit"]');
      if (!button || button.disabled) return;

      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');
      if (!variantInput) return;

      button.disabled = true;
      button.setAttribute("aria-disabled", "true");

      var payload = {
        items: [
          {
            id: Number(variantInput.value),
            quantity: quantityInput ? Number(quantityInput.value) || 1 : 1
          }
        ]
      };

      if (cart) {
        payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(",");
        payload.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(button);
        }
      }

      fetch((window.routes && window.routes.cart_add_url) || "/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript"
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json(); })
        .then(function (response) {
          if (response.status) throw new Error(response.description || "cart_add_failed");

          if (cart && response.sections) {
            if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
            cart.renderContents(response);

            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "ru-home-grid-prod-v2",
                cartData: response
              });
            }
            return;
          }

          window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        })
        .catch(function () {
          window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        })
        .finally(function () {
          button.disabled = false;
          button.removeAttribute("aria-disabled");
        });
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[id^="SectionRuHomeGridProdV2-"]').forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
